import { Mapper } from '@empathy/search-adapter';
import { Result } from '@empathy/search-types';
import { deepMerge } from '@empathybroker/deep-merge';
import { DeepPartial } from '@empathybroker/ebx-gluon';
import { injectable } from 'inversify';
import { CdlResult } from '../models/result.model';

@injectable()
export class CdlResultMapper implements Mapper<Result> {
  map(rawResult: any, result: Result): CdlResult {
    return deepMerge(result, {
      authors: rawResult.authors || [],
      bindingType: rawResult.bindingType || '',
      editions: [],
      infoMessage: '',
      id: rawResult.externalId,
      isLocalProduct: rawResult.isLocalProduct || false,
      name: this.shortenTitle(rawResult.name),
      fullName: rawResult.name,
      identifier: { value: rawResult.ean || rawResult.isbn },
      price: {
        value: null,
        originalValue: null,
        latamValue: null,
        latamOriginalValue: null,
        latamRefValue: null,
        latamRefOriginalValue: null,
        saving: null,
        used: null
      },
      rating: { value: rawResult.externalScore },
      tagging: {
        add2cart: {
          params: {
            productId: rawResult.externalId
          }
        }
      }
    } as DeepPartial<Result>);
  }

  shortenTitle(title: string): string {
    return title.length > 44 ? title.slice(0, 44).trim() + '...' : title;
  }
}
